import { cn } from '@utils/cn';
import type { ToastTone } from '@app-types/index';

export interface ToastProps {
  message: string;
  tone?: ToastTone;
  visible: boolean;
}

const TONES: Record<ToastTone, string> = {
  success: 'bg-t1 text-surface',
  info: 'bg-t1 text-surface',
  error: 'bg-accent-red text-white',
};

const DOT_TONES: Record<ToastTone, string> = {
  success: 'bg-accent-green',
  info: 'bg-accent-blue',
  error: 'bg-white',
};

export default function Toast({ message, tone = 'info', visible }: ToastProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'pointer-events-none fixed bottom-6 right-6 z-[9999] flex items-center gap-2 rounded-[10px] px-4 py-3 text-[13px] font-medium shadow-md transition-all duration-300',
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-[70px] opacity-0',
        TONES[tone],
      )}
    >
      <span className={cn('h-[7px] w-[7px] shrink-0 rounded-full', DOT_TONES[tone])} />
      <span>{message}</span>
    </div>
  );
}
